import { render, staticRenderFns } from "./biddingRemarkList.vue?vue&type=template&id=5c98a360&scoped=true&"
import script from "./biddingRemarkList.vue?vue&type=script&lang=js&"
export * from "./biddingRemarkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c98a360",
  null
  
)

export default component.exports